<template>
  <div>
    <el-row style="margin-bottom: 5px">
      <el-button type="primary" @click="addIPList" v-if="listOperations.some(func => func.name.includes('add'))">
        新增IP白/黑名单
      </el-button>
      <el-dropdown @command="setIPList" style="margin-left: 10px"
                   v-if="listOperations.some(func => func.name.includes('enable'))">
        <el-button type="danger">
          {{ buttonName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu>
          <el-dropdown-item command="1">启用白名单</el-dropdown-item>
          <el-dropdown-item command="2">启用黑名单</el-dropdown-item>
          <el-dropdown-item command="0">不启用</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="success" size="mini" icon="el-icon-s-opportunity" circle
                 style="margin-left: 200px"
                 @click="tipView=true"></el-button>
      <span style="float: right">
        <el-input placeholder="搜索" v-model="searchIp">
        <el-button slot="append" icon="el-icon-search" @click="getIPList"></el-button>
      </el-input>
      </span>
    </el-row>
    <el-row style="margin-bottom: 5px">
      <span v-if="listOperations.some(func => func.name.includes('edit'))">
        <el-button type="primary" size="medium" @click="editIPList(1,0,0)">一键开启</el-button>
        <el-button type="primary" size="medium" @click="editIPList(0,1,0)">一键关闭</el-button>
        <el-button type="primary" size="medium" @click="editIPList(0,0,1)">一键删除</el-button>
      </span>

<!--      <el-button v-if="listOperations.some(func => func.name.includes('reverse'))"-->
<!--        type="primary" size="medium" @click="reverseSelect" style="margin-left: 10px"-->
<!--                 :disabled="getIpType==0">反选-->
<!--      </el-button>-->
    </el-row>
    <el-col :span="12">
      <el-table :data="ipWhiteData" ref="whiteTable"
                style="width: 100%" border height="420"
                :row-class-name="greenShow"
                :header-cell-style="headerClassOne"
                @selection-change="whiteSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="ip" label="白名单" align="center"></el-table-column>
      </el-table>
    </el-col>
    <el-col :span="12">
      <el-table :data="ipBlackData" ref="blackTable"
                :row-class-name="greenShow"
                :header-cell-style="headerClassTwo"
                style="width: 100%" border height="420"
                @selection-change="blackSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="ip" label="黑名单" align="center"></el-table-column>
      </el-table>
    </el-col>
    <el-dialog title="新增" :visible.sync="ipListView" width="50%">
      <el-form :model="form" ref="form" :rules="rules">
        <div v-for="(data, initIpIdx) in form.initIpList">
          <el-row>
            <el-col :span="10">
              <el-form-item :prop="'initIpList' + '.' +initIpIdx + '.ip'" :rules="rules.ip">
                <el-tooltip class="item" effect="light" placement="top-start">
                  <div slot="content">
                    　<span>设置单个IP的白/黑名单 例;192.168.1.1</span><br/>
                    　<span>设置ip通配符,对一个ip段进行匹配 例:192.168.2.*</span><br/>
                    　<span>设置一个IP范围 例:192.168.12.17-192.168.12.150</span>
                  </div>
                  <i class="el-icon-question"/>
                </el-tooltip>
                <span style="margin-right: 10px">IP</span>
                <el-input v-model="data.ip" style="width:200px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-radio-group v-model="data.fenlei">
                  <el-radio :label="0">白</el-radio>
                  <el-radio :label="1">黑</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="float: right">
              <el-button type="primary" style="margin-left: 10px;"
                         icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
              <el-button type="warning" style="margin-left: 10px;" v-if="initIpIdx>0"
                         icon="el-icon-remove-outline" @click="delInput(initIpIdx)"></el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div style="text-align: center">
        <el-button @click="ipListView = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="小提示" :visible.sync="tipView" width="30%">
      <div>1. 白名单：仅有名单内的IP地址(高亮显示)可访问本系统内容</div>
      <div>2. 黑名单：仅有名单内的IP地址(高亮显示)不可访问本系统内容</div>
      <div>3. 如黑/白名单内无内容(高亮显示)，系统默认该功能未启用</div>
      <div>4. 黑名单与白名单不可同时启用,未启用名单侧所有IP均不生效</div>
      <div>5. 启用白名单时,请将您的出口IP、service_agent所处设备出口IP、PAAS所处设备出口IP添加置白名单，并且处于开启状态(高亮显示)</div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "IpLimit",
  data() {
    let IPValidator = (rule, value, callback) => {
      let common = [];
      let range = [];
      if (value == "") {
        callback(new Error('请输入正确IP地址'));
        return
      } else {
        if (value.indexOf("-") != -1) {
          range = value.split("-");
          let rangeOne = [];
          let rangeTwo = [];
          rangeOne = range[0].split(".");
          if (rangeOne.length != 4 || rangeOne[3] == "") {
            callback(new Error('IP地址格式错误'));
            return
          } else {
            for (let i = 0; i < rangeOne.length; i++) {
              if (rangeOne[i] < 0 || rangeOne[i] > 255) {
                callback(new Error('IP地址格式错误'));
                return
              }
            }
          }
          rangeTwo = range[1].split(".");
          if (rangeTwo.length != 4 || rangeTwo[3] == "") {
            callback(new Error('IP地址格式错误'));
            return
          } else {
            for (let i = 0; i < rangeTwo.length; i++) {
              if (rangeTwo[i] < 0 || rangeTwo[i] > 255) {
                callback(new Error('IP地址格式错误'));
                return
              }
            }
          }

          if (rangeOne[3] >= rangeTwo[3]) {
            if (rangeOne[2] >= rangeTwo[2]) {
              if (rangeOne[1] >= rangeTwo[1]) {
                if (rangeOne[0] >= rangeTwo[0]) {
                  callback(new Error('IP地址格式错误'));
                  return
                } else {
                  callback();
                }
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else {
            callback();
          }


        } else {
          common = value.split(".");
          if (common.length != 4 || common[3] == "") {
            callback(new Error('IP地址格式错误'));
            return
          } else {
            for (let i = 0; i < common.length; i++) {
              if (common[i] < 0 || common[i] > 255) {
                callback(new Error('IP地址格式错误'));
                return
              }
            }
          }
        }
        callback();
      }
    };
    return {
      ipWhiteData: [],
      ipBlackData: [],
      ipListView: false,
      tipView: false,
      form: {
        initIpList: [{
          ip: "",
          fenlei: 0
        }]
      },
      searchIp: "",
      getIpType: "",
      ipType: "",
      IpArr: [],
      whiteIpInfo: [],
      blackIpInfo: [],
      buttonName: "",
      rules: {
        ip: [
          {required: true, message: '请输入正确IP地址', validator: IPValidator, trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.getListOperations('ipLimit')
    if (!this.currentMenu) {
      return
    }
    this.getIPList()
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
  },
  methods: {
    ...mapMutations(['getListOperations']),
    greenShow({row, rowIndex}) {
      if (row.isUsed == 1) {
        return 'success-row';
      } else {
        return
      }
    },
    headerClassOne({row, rowIndex}) {
      if (this.getIpType == 1) {
        return "color:#24ff0f;"
      }
    },
    headerClassTwo({row, rowIndex}) {
      if (this.getIpType == 2) {
        return "color:#24ff0f;"
      }
    },
    // reverseSelect() {
    //   if (this.getIpType == 1) {
    //     if (this.ipWhiteData && this.ipWhiteData.length > 0) {
    //       this.ipWhiteData.forEach(e => {
    //         if (this.whiteIpInfo.indexOf(e) >= 0) {
    //           this.$refs.whiteTable.toggleRowSelection(e, false)
    //         } else {
    //           this.$refs.whiteTable.toggleRowSelection(e, true)
    //         }
    //       })
    //     }
    //
    //   } else if (this.getIpType == 2) {
    //     if (this.ipBlackData && this.ipBlackData.length > 0) {
    //       this.ipBlackData.forEach(e => {
    //         if (this.blackIpInfo.indexOf(e) >= 0) {
    //           this.$refs.blackTable.toggleRowSelection(e, false)
    //         } else {
    //           this.$refs.blackTable.toggleRowSelection(e, true)
    //         }
    //       })
    //     }
    //
    //
    //   }
    //
    // },
    whiteSelectionChange(val) {
      this.whiteIpInfo = val;
    },
    blackSelectionChange(val) {
      this.blackIpInfo = val;
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addIP();
        } else {
          this.$message.error('IP地址格式不正确！');
          return false;
        }
      });
    },
    addIPList() {
      this.ipListView = true;
      this.form.initIpList = []
      // if (this.form.initIpList.length == 0) {
      let obj = {
        ip: "",
        fenlei: 0
      };
      this.form.initIpList.push(obj);
      // }
    },
    addInput() {
      let addObj = {
        ip: "",
        fenlei: ""
      };
      this.form.initIpList.push(addObj);
    },
    delInput(idx) {
      this.form.initIpList.splice(idx, 1);
    },
    getIPList() {
      let data = {
        pageNo: 1,
        pageSize: 200,
        ip: this.searchIp
      };
      this.$axios.post(this.baseUrl3 + 'management3/ipManagement/getIpInfoByIp', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.ipWhiteData = data.ipWhite;
            this.ipBlackData = data.ipBlack;
            this.getIpType = data.type;
            if (this.getIpType == 0) {
              this.buttonName = "启用黑/白名单";
            } else if (this.getIpType == 1) {
              this.buttonName = "已启用白名单";
            } else if (this.getIpType == 2) {
              this.buttonName = "已启用黑名单";
            }

            if (this.ipWhiteData && this.ipWhiteData.length > 0) {
              this.ipWhiteData.forEach(e => {
                e.reverseFlag = false;
              });
            }

          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addIP() {
      this.IpArr = []
      for (let i = 0; i < this.form.initIpList.length; i++) {
        let isWhite;
        let isBlack;
        if (this.form.initIpList[i].fenlei == 0) {
          isWhite = 1;
          isBlack = 0
        } else {
          isWhite = 0;
          isBlack = 1
        }
        let obj = {
          ip: this.form.initIpList[i].ip,
          isUsed: 1,
          isWhite: isWhite,
          isBlack: isBlack,
          deleteFlag: 0,
        }
        this.IpArr.push(obj)
      }
      let data = {
        ipInfo: this.IpArr
      };
      this.$axios.post(this.baseUrl3 + 'management3/ipManagement/insert', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.getIPList();
            this.ipListView = false;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    setType() {
      let url = this.baseUrl3 + "management3/ipManagement/set/" + this.ipType;
      this.$axios.post(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success('设置成功！');
            this.getIPList();
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    setIPList(command) {
      this.ipType = command;
      if (command == 1) {
        this.$confirm('白名单或者黑名单一旦开启,处于高亮显示的ip会立即生效！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.setType();
          this.buttonName = "已启用白名单";
        }).catch(() => {

        });
      } else if (command == 2) {
        this.$confirm('白名单或者黑名单一旦开启,处于高亮显示的ip会立即生效！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.setType();
          this.buttonName = "已启用黑名单";
        }).catch(() => {

        });
      } else if (command == 0) {
        this.buttonName = "未启用";
        this.setType();
      }


    },
    editIPList(open, close, del) {
      let ipInfo;
      if (this.whiteIpInfo && this.whiteIpInfo.length > 0) {
        if (open == 1) {
          this.whiteIpInfo.forEach(e => {
            e.isUsed = 1;
          })
        } else if (close == 1) {
          this.whiteIpInfo.forEach(e => {
            e.isUsed = 0;
          });
        } else if (del == 1) {
          this.whiteIpInfo.forEach(e => {
            e.deleteFlag = 1;
          });
        }
        ipInfo = this.whiteIpInfo;
      }
      if (this.blackIpInfo && this.blackIpInfo.length > 0) {
        if (open == 1) {
          this.blackIpInfo.forEach(e => {
            e.isUsed = 1;
          })
        } else if (close == 1) {
          this.blackIpInfo.forEach(e => {
            e.isUsed = 0;
          });
        } else if (del == 1) {
          this.blackIpInfo.forEach(e => {
            e.deleteFlag = 1;
          });
        }
        ipInfo = this.blackIpInfo;
      }
      let data = {
        ipInfo: ipInfo
      };
      this.$axios.post(this.baseUrl3 + 'management3/ipManagement/update', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success('操作成功！');
            this.getIPList();
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  }
}
</script>

<style>
.el-table .success-row {
  color: #24ff0f;
}
</style>
